import React from "react";
import {ABreadcrumb, ACol, ARow} from "@cisco-sbg-ui/magna-react";
import {appConfig} from "config/defaultConfig";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import AssigneesWidget from "components/AssigneeWidget/AssigneeWidget";
import {selectIncidentDetail} from "store/selectors";
import IncidentTitle from "./IncidentTitle";
import InvestigateButton from "./InvestigateButton";
import LongDescription from "./LongDescription";
import MitreWidget from "./MitreWidget";
import ReportedBy from "./ReportedBy";
import ShortDescription from "./ShortDescription";
import StatusHeaderBar from "./StatusHeaderBar";

const {ROUTES} = appConfig.APP;

const IncidentDetailsSection = () => {
  const incident = useSelector(selectIncidentDetail);
  const {t} = useTranslation();

  return (
    <section
      className="incident-title-section mb-5"
      data-testid={"IncidentDetailsSection-Section"}>
      <ABreadcrumb
        style={{marginBottom: 20, padding: 0}}
        items={[
          {
            component: Link,
            content: t("breadcrumb.incidents"),
            contentProps: {
              to: ROUTES.INCIDENTS
            }
          }
        ]}
      />
      <ARow noGutters>
        <ACol>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "30px"
            }}>
            {/* left section */}
            <div
              style={{
                flex: "1 0 0",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                gap: "15px"
              }}>
              <StatusHeaderBar {...{incident}} />
              <div
                style={{
                  flex: "0 1 auto",
                  overflow: "hidden"
                }}>
                <IncidentTitle />
              </div>
              <div>
                <MitreWidget
                  labelProps={{style: {display: "none"}}}
                  {...{incident}}
                />
              </div>
            </div>
            {/* right section */}
            <div>
              <InvestigateButton />
            </div>
          </div>
        </ACol>
      </ARow>
      <ARow>
        <ACol>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "baseline",
              gap: "30px"
            }}>
            <ReportedBy {...{incident}} />
            <div
              style={{
                margin: "-5px 0" // prevent jumping when AssigneesWidget changes
              }}>
              <AssigneesWidget
                menuPlacement="bottom-right"
                tooltipPosition="top-right"
                showLabel={false}
                {...{incident}}
              />
            </div>
          </div>
        </ACol>
      </ARow>
      <ARow noGutters>
        <ACol>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px"
            }}>
            <div
              style={{
                flex: "0 1 auto",
                overflow: "hidden"
              }}>
              <ShortDescription />
            </div>
            <LongDescription />
          </div>
        </ACol>
      </ARow>
    </section>
  );
};

export default IncidentDetailsSection;
